import useFullScreen from "@/shared/atoms/useFullScreen";
import useWindowSize from "@/shared/hooks/useWindowSize";
import { Stage } from "konva/lib/Stage";
import { useEffect } from "react";
import { useSetTable } from "./useTable";
import useSideBarAtom from "@/shared/atoms/useSideBarAtom";

const useTablesMapHook = (ref: Stage) => {
  const window = useWindowSize();
  const [data] = useSideBarAtom();
  const [fullScreen] = useFullScreen();
  const width = ref?.attrs?.container?.clientWidth;

  const setSelectedTable = useSetTable();
  const key = `${width}-${JSON.stringify(window)}-${
    fullScreen ? "true" : "false"
  }-${JSON.stringify(data)}`;
  useEffect(() => {
    if (width) {
      ref.width(width);
    }
  }, [key]);

  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      setSelectedTable(undefined);
    }
  };
  return {
    width,
    checkDeselect,
    key,
  };
};

export default useTablesMapHook;
